import PropTypes from 'prop-types';

const metaShape = PropTypes.shape({
  className: PropTypes.string,
});

export const columnShape = PropTypes.shape({
  accessorKey: PropTypes.string,
  cell: PropTypes.elementType,
  header: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  id: PropTypes.string,
  meta: metaShape,
});

export const dataShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
});
